<div class="inscriptions">
  <!-- ===================== HERO ===================== -->
  <section class="inscriptions-hero" [class.inscriptions-hero--noSteps]="!showSteps">
    <div class="container">
      <header class="inscriptions-hero__head">
        <h1 class="inscriptions-hero__title">Inscripciones</h1>
        <p class="inscriptions-hero__eyebrow">
          Te acompañamos en cada paso del proceso de ingreso a nuestra comunidad educativa.
        </p>
      </header>

      <!-- ===================== TABS ===================== -->
      <div class="inscriptions-tabs">
        <div class="optionsList">
          <div
            class="option"
            *ngFor="let tab of tabs"
            (click)="setActiveTab(tab.id)"
            [class.activeOption]="activeTab === tab.id"
          >
            {{ tab.label }}
          </div>
          <div class="slide" [ngStyle]="getSlideStyles()"></div>
        </div>
      </div>

      <!-- Los pasos son sólo del circuito de Inicial / Primario / Secundario -->
      <ng-container *ngIf="showSteps">
        <h2 class="inscriptions-hero__stepsTitle">Pasos para el Ingreso</h2>

        <div class="inscriptions-steps">
          <ng-container *ngFor="let step of steps; let last = last">
            <article class="step-card">
              <span class="step-card__number">{{ step.number }}</span>
              <i class="step-card__icon" [ngClass]="step.icon" aria-hidden="true"></i>
              <h3 class="step-card__title">{{ step.title }}</h3>
              <p class="step-card__desc">{{ step.description }}</p>
            </article>

            <div class="inscriptions-steps__arrow" *ngIf="!last" aria-hidden="true">
              <i class="fas fa-arrow-right"></i>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </section>
  <!-- ===================== PREGUNTAS FRECUENTES ===================== -->
  <!-- <app-sblock-faq></app-sblock-faq> -->
  <!-- ===================== FORMULARIO ===================== -->
  <app-sblock-enrollment-form [levelKeys]="activeLevelKeys"></app-sblock-enrollment-form>


</div>
